import { Injectable, inject, signal } from '@angular/core';

import { CamGraphService } from '@camelot/server';
import { SessionStorage } from '@camelot/utils';

const visitorSessionKey = 'visitor-session';

type VisitorSession = {
  token: string | null;
};

@Injectable({
  providedIn: 'root',
})
export class VisitorTokenService {
  private readonly _graphService = inject(CamGraphService);

  public readonly session = signal(SessionStorage.get<VisitorSession>(visitorSessionKey));

  constructor() {
    this._graphService.visitor.set(this.session() !== null);
  }

  public open(token: string | null | undefined) {
    const session: VisitorSession = { token: token ?? null };

    SessionStorage.set(visitorSessionKey, session);
    this._setSession(session);
  }

  public close() {
    SessionStorage.delete(visitorSessionKey);
    this._setSession(null);
  }

  /** Le graph service bloque les requêtes non visiteur tant que la session est ouverte. */
  private _setSession(session: VisitorSession | null) {
    this.session.set(session);
    this._graphService.visitor.set(session !== null);
  }
}
